var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/schema";
const DEFAULT_PAGE_SIZE = 10;
const getArchivedHistories = fetcher.path("/api/histories/archived").method("get").create();
/**
 * Get a list of archived histories.
 */
export function fetchArchivedHistories(options = {}) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const params = optionsToApiParams(options);
        const { data, headers } = yield getArchivedHistories(params);
        const totalMatches = parseInt((_a = headers.get("total_matches")) !== null && _a !== void 0 ? _a : "0");
        if (params.view === "detailed") {
            return {
                histories: data,
                totalMatches,
            };
        }
        return {
            histories: data,
            totalMatches,
        };
    });
}
const archiveHistory = fetcher.path("/api/histories/{history_id}/archive").method("post").create();
/**
 * Archive a history.
 * @param historyId The history to archive
 * @param archiveExportId The optional archive export record to associate. This can be used to restore a snapshot copy of the history in the future.
 * @param purgeHistory Whether to purge the history after archiving. Can only be used in combination with an archive export record.
 * @returns The archived history summary.
 */
export function archiveHistoryById(historyId, archiveExportId, purgeHistory) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield archiveHistory({
            history_id: historyId,
            archive_export_id: archiveExportId,
            purge_history: purgeHistory,
        });
        return data;
    });
}
const unarchiveHistory = fetcher
    .path("/api/histories/{history_id}/archive/restore")
    .method("put")
    // @ts-ignore: workaround for optional query parameters in PUT. More info here https://github.com/ajaishankar/openapi-typescript-fetch/pull/55
    .create({ force: undefined });
/**
 * Unarchive/restore a history.
 * @param historyId The history to unarchive.
 * @param force Whether to force un-archiving for purged histories.
 * @returns The restored history summary.
 */
export function unarchiveHistoryById(historyId, force) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield unarchiveHistory({ history_id: historyId, force });
        return data;
    });
}
const reimportHistoryFromStore = fetcher.path("/api/histories/from_store_async").method("post").create();
/**
 * Reimport an archived history as a new copy from the associated export record.
 *
 * @param archivedHistory The archived history to reimport. It must have an associated export record.
 * @returns The async task result summary to track the reimport progress.
 */
export function reimportHistoryFromExportRecordAsync(archivedHistory) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!archivedHistory.export_record_data) {
            throw new Error("The archived history does not have an associated export record.");
        }
        const { data } = yield reimportHistoryFromStore({
            model_store_format: archivedHistory.export_record_data.model_store_format,
            store_content_uri: archivedHistory.export_record_data.target_uri,
        });
        return data;
    });
}
function optionsToApiParams(options) {
    var _a;
    const params = {};
    if (options.query) {
        params.q = ["name-contains"];
        params.qv = [options.query];
    }
    const pageSize = (_a = options.pageSize) !== null && _a !== void 0 ? _a : DEFAULT_PAGE_SIZE;
    params.offset = (options.currentPage ? options.currentPage - 1 : 0) * pageSize;
    params.limit = pageSize;
    params.order = options.sortBy ? `${options.sortBy}${options.sortDesc ? "-dsc" : "-asc"}` : undefined;
    params.view = options.view;
    params.keys = options.keys;
    return params;
}
